import routesLimited from '@/constants/routesLimited'
import type { RouteRecordRaw } from 'vue-router'

export const changelog: RouteRecordRaw = {
	component: () => import('components/modules/Changelog.vue'),
	meta: {
		title: 'Änderungshistorie',
		auth: true,
		limited: routesLimited.isAdminOrTeam,
	},
	name: 'changelog',
	path: '/changelog',
}
